<p>filter-analytics-dialog-box works!</p>
